import { FC } from 'react'
import { Edit, SimpleForm } from 'react-admin'
import { ActionsToolbar, HeaderTitle } from '../../components'
import NotificationConfigurationForm from './NotificationConfigurationForm'

const NotificationConfigurationsEdit: FC = () => (
  <Edit
    actions={<ActionsToolbar i18n="resources.notificationConfigurations.edit" />}
    title={<HeaderTitle i18n="resources.notificationConfigurations.edit" />}
    redirect={false}
    mutationMode="pessimistic"
  >
    <SimpleForm>
      <NotificationConfigurationForm />
    </SimpleForm>
  </Edit>
)

export default NotificationConfigurationsEdit
